module.exports = __webpack_public_path__ + "static/img/menu-product-l30.33f38c45.png";